import { render, staticRenderFns } from "./draggableList.vue?vue&type=template&id=0a987962&scoped=true"
import script from "./draggableList.vue?vue&type=script&lang=js"
export * from "./draggableList.vue?vue&type=script&lang=js"
import style0 from "./draggableList.vue?vue&type=style&index=0&id=0a987962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a987962",
  null
  
)

export default component.exports